var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoContacts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 276,
    viewBox: "0 0 263 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85059 18.1345C9.85059 8.11908 17.9697 0 27.9851 0H235.016C245.031 0 253.15 8.11909 253.15 18.1345V199.554C253.15 209.57 245.031 217.689 235.016 217.689H27.9851C17.9697 217.689 9.85059 209.57 9.85059 199.554V18.1345Z",
    fill: "#F2F4F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86.3628,
    y: 39.4844,
    width: 55.161,
    height: 5.62989,
    rx: 2.81494,
    fill: "#C1C5D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.73,
    x: 244.448,
    y: 36.3828,
    width: 167.366,
    height: 5.45642,
    rx: 2.72821,
    transform: "rotate(90 244.448 36.3828)",
    fill: "#E5E5E5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3628,
    y: 103.289,
    width: 55.161,
    height: 5.62989,
    rx: 2.81494,
    fill: "#C1C5D6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3628,
    y: 167.094,
    width: 55.161,
    height: 5.62989,
    rx: 2.81494,
    fill: "#C1C5D6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3628,
    y: 54.4922,
    width: 132.978,
    height: 5.62989,
    rx: 2.81494,
    fill: "#C1C5D6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3628,
    y: 118.305,
    width: 132.978,
    height: 5.62989,
    rx: 2.81494,
    fill: "#C1C5D6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 86.3628,
    y: 182.109,
    width: 132.978,
    height: 5.62989,
    rx: 2.81494,
    fill: "#C1C5D6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2319,
    y: 26.3438,
    width: 47.2809,
    height: 45.0391,
    rx: 12.6367,
    fill: "#C1C5D6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2319,
    y: 90.1484,
    width: 47.2809,
    height: 45.0391,
    rx: 12.6367,
    fill: "#C1C5D6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2319,
    y: 153.961,
    width: 47.2809,
    height: 45.0391,
    rx: 12.6367,
    fill: "#C1C5D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 83.8923C0 73.8769 8.11909 65.7578 18.1345 65.7578H244.866C254.881 65.7578 263 73.8769 263 83.8923V256.867C263 266.883 254.881 275.002 244.866 275.002H18.1345C8.11909 275.002 0 266.883 0 256.867V83.8923Z",
    fill: "url(#paint0_linear_3503_65126)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3503_65126",
    x1: 131.5,
    y1: 65.7578,
    x2: 131.913,
    y2: 242.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContacts);
export default __webpack_public_path__ + "static/media/no-contacts.854d7d99dd6ec06709a73f1868adfce9.svg";
export { ForwardRef as ReactComponent };